import { LoadingButton } from '@mui/lab';
import { Dialog, DialogTitle, DialogActions, Button } from '@mui/material';

const ConfirmDeleteDialog = ({ open, onClose, title, confirmDelete, isLoading }) => {
  return (
    <Dialog open={open} fullWidth maxWidth="xs" onClose={onClose}>
      <DialogTitle sx={{ textAlign: 'center' }} fontSize={10}>
        {title}
      </DialogTitle>
      <DialogActions sx={{ textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
        <LoadingButton
          color="error"
          variant="contained"
          loading={isLoading}
          onClick={() => {
            confirmDelete();
          }}
        >
          بله
        </LoadingButton>

        <Button variant="contained" color="inherit" onClick={onClose}>
          خیر
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteDialog;
